<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowCornerDown_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.125 3c.621 0 1.125.504 1.125 1.125v6.443c0 .653.277 1.296.797 1.782a2.96 2.96 0 0 0 2.016.775h9.096l-3.704-3.704a1.125 1.125 0 0 1 1.59-1.591l5.626 5.624c.439.44.439 1.152 0 1.592l-5.625 5.625a1.125 1.125 0 0 1-1.591-1.591l3.704-3.705H8.063c-1.32 0-2.599-.49-3.553-1.382A4.7 4.7 0 0 1 3 10.568V4.125C3 3.504 3.504 3 4.125 3"
        clip-rule="evenodd"
    />
</svg>
